const SETTING_KEY = 'anonymousSessionSetting';

const AnonymousSessionSetting = {
  get() {
    return JSON.parse(localStorage.getItem(SETTING_KEY));
  },
  set(value) {
    localStorage.setItem(SETTING_KEY, JSON.stringify(value));
  },
};

export default AnonymousSessionSetting;
